import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { removeReaction } from "../../../store/reactionSlice";
import "../FloatingReaction.css";

export default function FloatingReactionItem({ reaction, isSelf }) {
  const dispatch = useDispatch();
  const label = isSelf ? "Vous" : reaction.senderName || "";

  const randomX = Math.random() * 160 - 80;
  const randomDuration = 3 + Math.random() * 1.5;

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(removeReaction(reaction.id));
    }, randomDuration * 1000);
    return () => clearTimeout(timeout);
  }, [dispatch, reaction.id, randomDuration]);


  return (
    <div
      className="floating-reaction-item"
      style={{
        "--moveX": `${randomX}px`,
        "--duration": `${randomDuration}s`,
      }}
    >
      <img 
        src={reaction.gif} 
        className="floating-reaction-gif"
        alt="reaction"
      />

      {label && (
        <div className="floating-reaction-label">{label}</div>
      )}
    </div>
  );
}
